import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';
import { formatDateTimeInTzWithLocale } from '@utils/dateWithTz.tsx';

interface ComponentProps {
  updatedAt: string;
  updatedBy: string;
  timezoneId: string;
  dataTestId?: string;
}

const UpdatedBadge: React.FC<ComponentProps> = ({ updatedAt, updatedBy, timezoneId, dataTestId }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(updatedAt) && (
        <Badge filled={false} value={`${updatedBy}, ${formatDateTimeInTzWithLocale(updatedAt, timezoneId)}`} label={tr(`UpdatedBadge.title`, `Updated`)} highlightedValue={false} dataTestId={dataTestId}></Badge>
      )}
    </>
  );
};

export default UpdatedBadge;
